class pageScrollUtility {
  scrollToID(scrollDestinationID, topOffset) {
    const startY = this.currentYPosition();
    const stopY = this.elmYPosition(scrollDestinationID, topOffset);
    const distance = stopY > startY ? stopY - startY : startY - stopY;
    if (distance < 100) {
      scrollTo(0, stopY);
      return;
    }
    const speed = 15;
    const step = Math.round(distance / 25);
    let leapY = stopY > startY ? startY + step : startY - step;
    let timer = 0;
    if (stopY > startY) {
      for (let i = startY; i < stopY; i += step) {
        setTimeout(`window.scrollTo(0, ${leapY})`, timer * speed);
        leapY += step;
        if (leapY > stopY) leapY = stopY;
        timer += 1;
      }
      return;
    }
    for (let i = startY; i > stopY; i -= step) {
      setTimeout(`window.scrollTo(0, ${leapY})`, timer * speed);
      leapY -= step;
      if (leapY < stopY) leapY = stopY;
      timer += 1;
    }
  }
  currentYPosition() {
    // Firefox, Chrome, Opera, Safari
    if (self.pageYOffset) return self.pageYOffset;
    // Internet Explorer 6 - standards mode
    if (document.documentElement && document.documentElement.scrollTop) return document.documentElement.scrollTop;
    // Internet Explorer 6, 7 and 8
    if (document.body.scrollTop) return document.body.scrollTop;
    return 0;
  }

  /**
   * Get element's Y position
   * @param {object} eID - element ID
   * @param {number} topOffset - additional space between element and top of the page -
   * accounts for sticky or any other offset
   * @return {number} element's Y position
   */
  elmYPosition(eID, topOffset) {
    const elm = document.getElementById(eID);
    let y = elm.offsetTop;
    let node = elm;
    while (node.offsetParent && node.offsetParent != document.body) {
      node = node.offsetParent;
      y += node.offsetTop;
    }
    return topOffset ? y - topOffset : y;
  }
}
var index = new pageScrollUtility();

export { index as default };
